<div class="view-container">
  <div class="center">
    <h1>404</h1>
    <p>Oops something went wrong <br> Sorry!</p>
  </div>
</div>
